import * as React from 'react';
import { ProductContext } from '../../../pages/ProductStencil';
import { IProductStencilContext } from '../product-stencil.types';

export const Breadcrumb = () => {
    const productData = React.useContext(ProductContext);
    const breadcrumb = productData.breadcrumb as IProductStencilContext["breadcrumb"];

    return (
        <div className="pdp__breadcrumb">
            <ul>
                {breadcrumb.elements.map((element, index) => (
                    <li key={index}>
                        {element.url ? (
                            <a href={element.url + (element.queryParams ? `?${new URLSearchParams(element.queryParams).toString()}` : '')}>
                                {element.label}
                            </a>
                        ) : (
                            <span>{element.label}</span>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    );
};
